/**
 * Returns true if the store is currently paused for fulfilment.
 * Uses UTC dates to avoid timezone inconsistencies.
 */
export const isStorePaused = () => {
  const now = new Date()

  // Pause starts at midnight UK time (GMT)
  const pauseStart = new Date("2026-01-04T00:00:00Z")

  const pauseEnd = new Date("2026-03-14T00:00:00Z") // Reopens March 14th

  return now >= pauseStart && now < pauseEnd
}

export const storePausedMessage =
  "We're taking a short break and have temporarily paused shipping. You're welcome to browse — ordering reopens on March 14th."

/**
 * Returns true if orders can still be placed, but shipping is delayed.
 */
export const isShippingDelayed = () => {
  const now = new Date()

  // Shipping delay window
  const delayStart = new Date("2026-06-27T00:00:00Z")
  const delayEnd = new Date("2026-07-06T00:00:00Z")

  return now >= delayStart && now < delayEnd
}

export const shippingDelayMessage =
  "Orders placed now will be shipped from July 6th. Thank you for your patience."
